// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xiDAKk58vfamwR {
  width: 100%;
}
.Hdr1lvVT_9hdOt {
  display: block;
  flex-shrink: 0;
  align-self: flex-start;
  padding: var(--ds-space-0, 0) 6px;
  flex-grow: 1;
  height: 100%;
}
.Hdr1lvVT_9hdOt[hidden] {
  display: none;
}
@media print {
  .Hdr1lvVT_9hdOt {
    display: none;
  }
}
.hCjCvLRiJAOgje {
  justify-content: flex-start;
  width: 272px;
  padding: var(--ds-space-150, 12px);
  border-radius: var(--ds-border-radius-300, 12px);
  background-color: #ffffff3d;
}
.EC2E0FZ94LL8vm {
  background-color: #ffffff3d;
  color: var(--dynamic-text);
}
`, ""]);
// Exports
export var buttonListContainer = `xiDAKk58vfamwR`;
export var addListButtonContainer = `Hdr1lvVT_9hdOt`;
export var addListButton = `hCjCvLRiJAOgje`;
export var limitMessage = `EC2E0FZ94LL8vm`;
export default ___CSS_LOADER_EXPORT___;
